import React from 'react'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import PanelKinerja from 'app/KinerjaPage/components/PanelKinerja'
import useSKP from 'app/KinerjaPage/hooks/useSKP'
import StickyFooter from 'app/KinerjaPage/components/StickyFooter'
import useContentContext from 'app/KinerjaPage/hooks/useContentContext'
import useToggleSdkContext from 'utils/useToogleSdk'

import type { Kinerja } from 'types/kinerja'

import IconBookRaporGraphicDoc from 'assets/icons/img-book-rapor-graphic-doc.svg'

interface TabHasilKerjaTambahanProps {
  skp: Kinerja
  onClickNext?: () => void
}

const TabHasilKerjaTambahan = ({
  skp,
  onClickNext = () => {},
}: TabHasilKerjaTambahanProps) => {
  const toggles = useToggleSdkContext()
  const { isEmptyTugasTambahan, getChangesTugasTambahanByIndex } = useSKP(skp)
  const { getTugasTambahanById } = useContentContext()

  const isHidePointEnabled =
    toggles?.['kinerja-hide-rhk-point-enabled'] === true
  const isNewFlow = isHidePointEnabled && skp.tahun > 2024

  return (
    <>
      <div className="p-9">
        <div className="flex flex-col gap-9">
          {skp.status === 'APPROVED' && (
            <div className="flex gap-3">
              <IconBookRaporGraphicDoc className="w-16 h-16 shrink-0" />
              <div>
                <Text variant="display-sm">
                  Cek Perencanaan Kinerja yang disetujui atasan
                </Text>
                <Text className="mt-1.5">
                  Kata “Ada penyesuaian” artinya atasan mengubah Rencana Hasil
                  Kerja Anda. Mohon perhatikan dan lanjut sepakati, ya.
                </Text>
              </div>
            </div>
          )}

          {isEmptyTugasTambahan ? (
            <PanelKinerja
              data-testid="PanelKinerjaTambahan-empty"
              originalKinerja={getTugasTambahanById(skp.tugasTambahan[0]?.id)}
              number={1}
              linkGuide=""
              showChange
              showDetails={!isNewFlow}
            />
          ) : (
            skp.reviewTugasTambahan.map((_, index) => {
              const { originalNumber, originalKinerja, kinerja } =
                getChangesTugasTambahanByIndex(index)

              return (
                <PanelKinerja
                  key={`tugasTambahan-${index}`}
                  data-testid={`tugasTambahan-${index}`}
                  originalKinerjaNumber={originalNumber}
                  originalKinerja={originalKinerja}
                  number={index + 1}
                  kinerja={kinerja}
                  showChange
                  showDetails={!isNewFlow}
                />
              )
            })
          )}
        </div>
      </div>

      <StickyFooter>
        <Button
          size="lg"
          color="black"
          onClick={() => onClickNext()}
          type="button"
          data-testid="btn-next"
        >
          Ke Perilaku Kerja
        </Button>
      </StickyFooter>
    </>
  )
}

export default TabHasilKerjaTambahan
